
import React, {Component} from 'react';

import Paper from '@material-ui/core/Paper';
  
class Home extends Component {
  render() {
    return (
      <div align="center" style={{ marginTop: '20vh', marginLeft: '5%', width: '80%', fontFamily: 'Titilium',textShadow: '1px 1px 1px black'}}>
    <Paper style={{padding: "3%", backgroundColor: 'rgba(223,229,221,0.15)'}}>
     <h1 style={{opacity: 2, width: '80%', fontStyle: 'bold',fontSize: '45px', color : 'white',  }}>Random Matrices, Stochastic Models and Analysis </h1> 
     <h2 style={{shadow: '100',width: '80%', fontStyle: 'bold',fontSize: '45px',color :'#009688'}}> Royal Institute of Technology </h2> 
     <p style={{width: '80%', fontStyle: 'bold',fontSize: '20px', color: 'white'}}>
       Welcome to the homepage of the group "Random matrices, Stochastic Models and Analysis". On this page you will find useful information about the members of the group and our research activities.
       </p>
       <p style={{marginTop:'10%', width: '80%', fontStyle: 'bold',fontSize: '20px', color: 'white'}}>
       Supported by the  European Reseach Council, the Knut and Alice Wallenberg Foundations, the Swedish Research Council and the Göran Gustafsson Foundation (KTH/UU)
       </p>

       </Paper>
     </div>
    );
  }
}

export default Home;